import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ListItem} from "../../../objects/listItem";
import {ListingModel} from "../../../objects/listing-model";
import {SubscriptionLike} from "rxjs";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {AppEvent} from "../../../objects/appEvent";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {User} from "../../../objects/user";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {File} from "../../../objects/file";

@Component({
  selector: 'app-class-details-component',
  templateUrl: './class-details.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class ClassDetailsComponent implements OnInit {

  state: string = 'loading';
  hasRelationRequest: boolean = false;
  errMsg: string = '';
  events: object[];
  games: object[];
  players: ListItem[];
  class: object;
  isClassOwner: boolean = false;
  profileClassRelation: string;
  config: object;
  activeItem: ListItem; // Element on which was called context menu
  listing: ListingModel;
  scrollTop = 0;
  firstItemHeight = 270;
  typicalItemHeight = 94; //94 activity, 80 users
  cupCheckerInterval = 10000;
  listToggleState: string = 'activity';
  groupUsers: ListItem[];
  //private cupPlayerPreviewID = 0;
  private cupCheckInterval = null;
  private cupCheckPending = false;

  @Input() viewID: string; //before component init
  private sharedEventSubscription: SubscriptionLike;

  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  constructor(public application: AppComponent,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.listToggleState = this.application.getUrlParam('toggle_state') ? this.application.getUrlParam('toggle_state') : this.listToggleState;
    this.listing = new ListingModel();
    if(this.application.getUrlParam('show_cup_players')) {
      //this.state = 'cup_players_view';
      this.state = 'loading';
      let showActiveGame = this.application.getUrlParam('show_active_game') ? true : false;
      this.application.apiService.getCupDetails(environment['gid'],environment['g_hash'],this.viewID)
        .subscribe(
          data => this.handleCupDetails(data,false,showActiveGame),
          error => this.handleItemsError(error))
    } else {
      this.itemViewPicked(this.viewID)
    }
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        // if (appEvent.type === AppEvent.USER_SELECTED) { //user switch
        //   this.viewID = appEvent.data['userID'];
        //   this.itemViewPicked(this.viewID)
        // }
        if (appEvent.type === AppEvent.CLASS_SELECTED) { //user switch
          this.viewID = appEvent.data['classID'];
          this.itemViewPicked(this.viewID)
        }
        if (appEvent.type === AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED) {
          console.log('AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED','class-view');
          //reload list
          this.state = 'loading'
          setTimeout(() => {
            if(appEvent.data['vizavi_player_to_open_later'] && !appEvent.data['skip_player_popup_open']) {
              console.log('trigger 1 AppEvent.CUP_PLAYER_VIEW_OPEN');
              let appEventForOpen = new AppEvent(AppEvent.CUP_PLAYER_VIEW_OPEN, {player_id: appEvent.data['vizavi_player_to_open_later']});
              this.sharedDataService.pushAppEvent(appEventForOpen)
            }
          }, 100)
          setTimeout(() => { this.handleCupDetails(appEvent.data) }, 100)
        }
        if (appEvent.type === AppEvent.CUP_PLAYER_VIEW_OPEN) {
          console.log('AppEvent.CUP_PLAYER_VIEW_OPEN');
          //this.cupPlayerPreviewID = appEvent.data['player_id']
          this.openPlayer(appEvent)
        }
        // if (appEvent.type === AppEvent.CUP_PLAYER_STATUS_CHANGED) {
        //   console.log('AppEvent.CUP_PLAYER_STATUS_CHANGED',1);
        // }
        if (appEvent.type === AppEvent.CLASS_EVENT_ADDED && appEvent.data['class_uuid'] == this.class['uuid']) {
          this.listing.addListItem(appEvent.data['listItem']);
        }
        if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED) {
          this.checkProfileClassRelation();
        }
        if (appEvent.type === AppEvent.GAME_CREATED) {
          this.toggleActivity();
          this.itemViewPicked(this.viewID,true) //class refresh
        }
        if (appEvent.type === AppEvent.EVENT_DELETED) {
          this.itemDeleted(appEvent.data['item']) //class refresh
        }
        if (appEvent.type === AppEvent.CLASS_MENU_EVENT) {
          switch (appEvent.data['menuEvent']) {
            case 'generate_subscription':
              this.generateSubscribeEvent()
              break;
            case 'send_group_message':
              this.sendGroupMessage()
              break;
            case 'add_game_result':
              this.addGame()
              break;
            case 'more_info':
              this.moreInfo()
              break;
            case 'copy_link':
              this.shareLinkPopup()
              break;
            case 'my_play_conf':
              this.requestPlayConfig(true)
              break;
            case 'exit_group':
              this.exitPopup()
              break;
          }
        }
      });
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
    this.clearCupCheckerInterval();
  }

  private itemViewPicked(itemID,silentRefresh = false) {
    if(!silentRefresh) this.state = 'loading';
    this.application.apiService.getClassEvents(environment['gid'],itemID,environment['g_hash'])
      .subscribe(
        data => this.handleEventsItems(data),
        error => this.handleItemsError(error))
  }

  private handleCupDetails(data, lightUpdate = false, showActiveGame = false) {
    if(!lightUpdate) {
      setInterval(() => this.setupSlotCheckerInterval(), this.cupCheckerInterval) //set initial checker with delay
      this.class = data['class'];
      this.events = [];
      this.games = data['games'];
      this.players = this.application.apiService.extractProfilesData(data['players'],'climb_cup_player');
      this.config = JSON.parse(this.class['configuration'])
      this.state = 'cup_players_view';
      if(showActiveGame && data['playersByIdx'][this.application.user.id+'']['has_active_game']) {
        setTimeout(() => {
          let lastGame = data['playersByIdx'][this.application.user.id+'']['games'][0]['gamePayload'];
          let vizaviID = (lastGame['player_id'] == this.application.user.id) ? lastGame['vizavi_id'] : lastGame['player_id'];
          console.log('trigger 2 AppEvent.CUP_PLAYER_VIEW_OPEN');
          let appEventForOpen = new AppEvent(AppEvent.CUP_PLAYER_VIEW_OPEN, {player_id: vizaviID});
          this.sharedDataService.pushAppEvent(appEventForOpen)
        }, 100)
      }
    } else {
      let games = data['games'];
      //let freshPlayersByIdx = this.application.apiService.extractProfilesData(data['playersByIdx']);
      let freshPlayersByIdx = data['playersByIdx'];
      console.log('playersByIdx',freshPlayersByIdx)
      let emitListingRefresh = false;
      this.players.forEach(player => {
        let freshPlayer = freshPlayersByIdx[player['itemFullData']['id']+''];
        if(freshPlayer) {
          let oldStatus = player['itemFullData']['call_game_description'];
          let newStatus = freshPlayer['call_game_description'];
          let oldCupPosition = player['itemFullData']['cup_position'];
          let newCupPosition = freshPlayer['cup_position'];

          player['itemFullData']['call_game_status'] = freshPlayer['call_game_status'];
          player['itemFullData']['call_game_description'] = newStatus;
          player['itemFullData']['cup_position'] = newCupPosition;
          player['itemFullData']['has_active_game'] = freshPlayer['has_active_game'];

          let lastFreshGame = freshPlayer['games'].length ? freshPlayer['games'][0]['gamePayload'] : null;
          //check if player game changed
          //and force update if cup-player-info-popup opened for that game
          if(player['itemFullData']['games'].length != freshPlayer['games'].length ||
            (player['itemFullData']['games'].length &&
              (player['itemFullData']['games'][0]['gamePayload']['status'] != lastFreshGame['status'] ||
               player['itemFullData']['games'][0]['gamePayload']['score'] != lastFreshGame['score'] ||
               player['itemFullData']['games'][0]['gamePayload']['result'] != lastFreshGame['result']
              )
            )
          ) {
            player['itemFullData']['games'] = freshPlayer['games'];
            //if game changes for application.user.id - refresh listing and show notice
            //if(player['itemFullData']['id'] == this.application.user.id) {
            if(1) {
              //force listing refresh and vizavi player popup open if needed
              //should happen after all player's games updated - needed for opened player popup
              emitListingRefresh = true;
              if(player['itemFullData']['id'] == this.application.user.id && lastFreshGame) {
                data['vizavi_player_to_open_later'] = (lastFreshGame['player_id'] == this.application.user.id) ? lastFreshGame['vizavi_id'] : lastFreshGame['player_id'];
              }
              // let notification = new FS3Notification();
              // notification.type = 'success';
              // notification.text = AppComponent.getLabel('cup_player_status_changed');
              // this.sharedDataService.pushNotification(notification);
            }
            // if(freshPlayer['games'].length && (
            //    freshPlayer['games'][0]['gamePayload']['player_id']==this.application.user.id ||
            //    freshPlayer['games'][0]['gamePayload']['vizavi_id']==this.application.user.id
            // )) { //relevant game changes
            // }
          } else if(player['itemFullData']['id'] == this.application.user.id && oldCupPosition != newCupPosition) {
            // let notification = new FS3Notification();
            // notification.type = 'success';
            // notification.text = AppComponent.getLabel('cup_player_position_changed');
            // this.sharedDataService.pushNotification(notification);
          }

          // if(oldStatus != newStatus && (oldStatus.match(/^mutual/) || newStatus.match(/^mutual/))) {
          //   let notification = new FS3Notification();
          //   notification.type = 'success';
          //   notification.text = 'cup_status_changed';
          //   this.sharedDataService.pushNotification(notification);
          //   //let appEvent = new AppEvent(AppEvent.CUP_PLAYER_STATUS_CHANGED, {playerID: player['id'], oldStatus: oldStatus, newStatus: newStatus});
          //   let appEvent = new AppEvent(AppEvent.MUTUAL_CUP_GAME_CHANGE, data);
          //   this.sharedDataService.pushAppEvent(appEvent)
          // } else if(player['itemFullData']['id'] == this.application.user.id && oldCupPosition != newCupPosition) {
          //   let notification = new FS3Notification();
          //   notification.type = 'success';
          //   notification.text = 'position_changed';
          //   this.sharedDataService.pushNotification(notification);
          // }
        }
      })
      if(emitListingRefresh) {
        let appEvent = new AppEvent(AppEvent.CUP_PLAYER_GAME_STATUS_CHANGED, data);
        this.sharedDataService.pushAppEvent(appEvent)
        let notification = new FS3Notification();
        notification.type = 'success';
        notification.text = AppComponent.getLabel('cup_changes_occur');
        this.sharedDataService.pushNotification(notification);
      }
    }
  }
  private setupSlotCheckerInterval() {
    if (!this.cupCheckInterval) {
      this.cupCheckInterval = setInterval(() => this.cupChecker(), this.cupCheckerInterval)
      this.cupChecker();
    }
  }
  private clearCupCheckerInterval() {
    if (this.cupCheckInterval) {
      clearInterval(this.cupCheckInterval);
      this.cupCheckInterval = null;
    }
  }
  cupChecker() {
    if(this.cupCheckPending) return;
    this.cupCheckPending = true;
    this.application.apiService.getCupDetails(environment['gid'],environment['g_hash'],this.viewID)
      .subscribe(
        data => { this.cupCheckPending = false; this.handleCupDetails(data, true)},
        error => { this.cupCheckPending = false; })
  }

  private handleEventsItems(data) {
    this.events = data['events'];
    this.class = data['class'];
    this.config = JSON.parse(this.class['configuration'])
    this.checkProfileClassRelation();
    //console.log('this.profileClassRelation',this.profileClassRelation)
    this.groupUsers = this.application.apiService.extractProfilesData(this.class['profiles']);
    this.setListingItems();
    this.activeItem = this.listing.listItems[0];
    this.state = 'item_view';
    setTimeout(() => {
      // better to set viewport size explicitly vs some extra bottom offset
      this.viewport.setTotalContentSize(this.firstItemHeight + this.typicalItemHeight * (this.listing.listItems.length + 0.2))
    });
  }
  private handleItemsError(error) {
    this.state = 'error';
    this.errMsg = error.errMsg;
  }
  private setListingItems() {
    let items;
    switch (this.listToggleState) {
      case 'activity':
        this.typicalItemHeight = 94;
        items = this.application.apiService.extractClubEventsData(this.events);
        break;
      case 'users':
        this.typicalItemHeight = 80;
        items = this.application.apiService.extractProfilesData(this.class['profiles']);
        items.sort((a: ListItem, b: ListItem) => {
          const compA = parseInt(a.itemFullData['rank']);
          const compB = parseInt(b.itemFullData['rank']);
          return (compA === compB) ? 0 : ((compA > compB) ? -1 : 1);
        })
        break;
    }
    //console.log('items',items)
    this.listing.listItems = [...items];
  }
  private checkProfileClassRelation() {
    this.isClassOwner = (this.application.user.id == this.class['profile_id']);
    this.profileClassRelation = User.findProfileClassRelation(this.application.user,this.class['id']);
    //used in mobile container state=class_view top right menu
    let appEvent = new AppEvent(AppEvent.CLASS_CHECKED, {
      "isClassOwner":this.isClassOwner,
      "classConfig":this.config,
      "profileClassRelation":this.profileClassRelation
    });
    this.sharedDataService.pushAppEvent(appEvent)
    this.hasRelationRequest = false;
  }
  comingSoon() {
    const event = new FS3Notification();
    event.text = AppComponent.getLabel('coming_soon');
    event.type = 'info';
    this.sharedDataService.pushNotification(event);
  }
  onScroll(event) {
    //console.log('onScroll',event,(event.target as Element).scrollTop);
    this.scrollTop = (event.target as Element).scrollTop;
  }
  toggleActivity() {
    this.scrollTop = 0;
    this.listToggleState = 'activity'
    this.setListingItems()
  }
  toggleUsers() {
    this.scrollTop = 0;
    this.listToggleState = 'users'
    this.setListingItems()
  }
  public userClick(event, listItem) {
    if(listItem.itemFullData['id'] == this.application.user.id) return;
    //console.log('listItem',listItem)
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '280px',
      minHeight: '280px',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'game-proposal',
        payload: {
          profile: listItem.itemFullData,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed',confirmed);
      })
  }
  public usersListRippleDisabled = false;
  public userMenuClick(event) {
    event?.stopImmediatePropagation()
  }
  public userMenuTouchEnd(event) {
    setTimeout(() => {this.usersListRippleDisabled = false}, 500)
  }
  exitPopup() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('exit_from_group_popup_title'),
        message: AppComponent.getLabel('exit_from_group_popup_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          this.doRelationRequest('exit_class')
        }
      })
  }
  showUserProfile(listItem) {
    window.open('/'+this.application.appLang+'/squash/userview/'+listItem.itemFullData['id'], "_blank");
  }
  getUserContact(listItem) {
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }
    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '__profile_contact_'+listItem.itemFullData['id']+'_'+listItem.itemFullData['sig'];
      window.open(environment['viber_url']+exit_context)
    }
  }
  sendUserMessage(listItem) {
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }
    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '__start_private_chat_with_user_'+listItem.itemFullData['id']+'_'+listItem.itemFullData['sig'];
      window.open(environment['viber_url']+exit_context)
    }
  }
  sendGroupMessage() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('message_group_title'),
        message: AppComponent.getLabel('message_group_body'),
        //cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('continue_in_chat_bot2')
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          if(!environment['mobile_exit_strategy']) {
            window.alert('missing mobile_exit_strategy');
            return;
          }

          if(environment['mobile_exit_strategy'] === 'viber') {
            let exit_context = '__start_group_chat_'+this.class['id'];
            window.open(environment['viber_url']+exit_context)
          }
        }
      })
  }
  addGame() {
    const commonDialogConf = {
      autoFocus: false,
      panelClass: 'common-dialog'
    }
    let listItem = new ListItem();
    listItem.itemFullData = {
      type: "game_proposal",
      cid: this.class['id'],
      class_uuid: this.class['uuid']
    };
    listItem.itemFullData['payload_parsed'] = {
      "type": "game_proposal",
      "player_id": 0,
      "vizavi_id": 0,
      "pickedDateTime": "",
      "status": "confirmed",
      "profiles": [{
        "id": 0,
        "shipping_name": "N/A",
        "picture_src_preview": environment['logo_server']+"/images/assets/def_prof_preview_male.png",
        "rank": '',
        "rank_add": 0
      },{
        "id": 0,
        "shipping_name": "N/A",
        "picture_src_preview": environment['logo_server']+"/images/assets/def_prof_preview_male.png",
        "rank": '',
        "rank_add": 0
      }],
      "result": "",
      "score": ""
    }
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      ...commonDialogConf,
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'event-open',
        payload: {item: listItem, mode: 'edit_game', users: this.groupUsers},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          console.log('dialogPayload',dialogPayload)
        }
      })
  }
  moreInfo() {
    let config = JSON.parse(this.class['configuration'])
    window.open(config['link'])
  }
  shareLinkPopup() {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'share-link',
        payload: {
          link: this.config['link'],
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
  }
  generateSubscribeEvent() {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '50%',
      minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'subscribe-event-form',
        payload: {
          classItem: this.class,
          item: null,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed',confirmed);
      })
  }
  pickClassForAction() {
    if(this.config['type'] == 'user_class' && !this.isClassOwner && !this.profileClassRelation) {
      if(this.config['provide_play_config_on_join']) {
        this.requestPlayConfig(false)
      } else {
        this.doRelationRequest()
      }
    } else if(this.config['type'] == 'cup') {
      let notification = new FS3Notification();
      notification.type = 'info';
      notification.text = AppComponent.getLabel('cups_stopped');
      this.sharedDataService.pushNotification(notification);
    } else if(this.config['type'] == 'subscribe_event') {
      if(environment['mobile_exit_strategy'] === 'viber') {
        let exit_context = '__club_class_pick_'+this.viewID+'_'+this.class['sig'];
        window.open(environment['viber_url']+exit_context)
      }
    }
  }
  requestPlayConfig(publish_group_event) {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '50%',
      minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      data: {
        application: this.application,
        state: 'play-config-form',
        payload: {
          classItem: this.class,
          publish_group_event: publish_group_event,
          item: null,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        //console.log('confirmed',confirmed);
        if(confirmed) {
          this.doRelationRequest()
        }
      })
  }
  doRelationRequest(directAction = '') {
    let relationRequest;
    if(directAction) {
      relationRequest = this.application.apiService.relationConfirmation(environment['gid'],environment['g_hash'],0,this.class['id'],directAction)
    } else if(this.config['privacy'] == 'confirmation') {
      relationRequest = this.application.apiService.relationConfirmation(environment['gid'],environment['g_hash'],0,this.class['id'],'join_class_request')
    } else { //maybe public
      relationRequest = this.application.apiService.relationConfirmation(environment['gid'],environment['g_hash'],0,this.class['id'],'join_class')
    }
    this.hasRelationRequest = true;
    relationRequest.subscribe(
      data => {
        //this.hasRelationRequest = false;
        this.application.getCurrentUser(); //refresh user
        this.itemViewPicked(this.viewID,true) //class refresh
        let joinText = '';
        if(this.config['privacy'] == 'confirmation') {
          joinText = AppComponent.getLabel('send_friendship_request_popup_confirmation');
        } else {
          joinText = AppComponent.getLabel('updated');
        }
        let notification = new FS3Notification();
        notification.type = 'success';
        notification.text = joinText;
        this.sharedDataService.pushNotification(notification);
      },
      error => {
        this.hasRelationRequest = false;
        const { exception } = error;
        if (exception && exception.error && exception.error.message) {
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = exception.error.message;
          this.sharedDataService.pushNotification(notification);
        }
      })
  }

  protected itemDeleted(deletedItem:ListItem) {
    this.events = [...this.events.filter(event => event['id'] != deletedItem['itemFullData']['id'])]
    if(this.listToggleState == 'activity') {
      let items;
      items = this.application.apiService.extractClubEventsData(this.events);
      this.listing.listItems = [...items];
    }
  }

  protected openPlayer(appEvent) {
    let listItem = this.players.find(player => player.itemFullData['id'] == appEvent.data['player_id'])
    const commonDialogConf = {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
    }
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'cup-player-info-popup',
        payload: {item: listItem, listPayload: {class: this.class, players: this.players, games: this.games}},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed().subscribe(() => {
      // let appEvent = new AppEvent(AppEvent.CUP_PLAYER_VIEW_CLOSE, {player_id: this.listItem.itemFullData['id']});
      // this.sharedDataService.pushAppEvent(appEvent);
    })
  }
}
